<template>
  <component :is="formComponent" v-bind="formProps" />
</template>

<script>
import Student from "./student.vue";
import StudentTcfForm from "./studentTcfForm.vue";

export default {
  name: "StudentFormEntry",
  components: {
    Student,
    StudentTcfForm,
  },
  computed: {
    reportDomain() {
      return (this.$store.state.report || "").replace(/_/g, "");
    },
    isTcfDomain() {
      return ["myskooltcfdemo", "myskooltcf"].includes(this.reportDomain);
    },
    formComponent() {
      return this.isTcfDomain ? "StudentTcfForm" : "Student";
    },
    formProps() {
      return {
        selected: this.$route.params.selected,
        id: this.$route.params.id,
        inqObj: this.$route.params.inqObj,
      };
    },
  },
};
</script>
